import React, { useState, useEffect } from "react";
import { Modal, Button } from "react-bootstrap";
import { Spin } from "antd";
import TransactionDetails from "../transactionDetails";
import axios from "axios";

const RealAuthTransactionsModalForWeb = ({ visible, onClose, order, timezone }) => {
  const [loading, setLoading] = useState(false);
  const [transactions, setTransactions] = useState([]);
  const [activeTab, setActiveTab] = useState(0);
  
  useEffect(() => {
    if (visible && order && order.real_auth_transactions && order.real_auth_transactions.length > 0) {
      fetchTransactionDetails();
    }
  }, [visible, order]);
  
  const fetchTransactionDetails = async () => {
    if (!order || !order.real_auth_transactions || order.real_auth_transactions.length === 0) {
      return;
    }
    
    setLoading(true);
    
    try {
      // Fetch each transaction's details
      const transactionPromises = order.real_auth_transactions.map(transId => {
        const token = localStorage.getItem("accessToken");
        return axios.get(`${process.env.REACT_APP_API_BASE_URL}/fetch-data/transactions/${transId}/`, {
          headers: {
            "Authorization": `Bearer ${token}`,
            "Content-Type": "application/json"
          }
        });
      });
      
      const responses = await Promise.all(transactionPromises);
      const transactionData = responses.map(response => response.data);
      setTransactions(transactionData);
    } catch (error) {
      console.error("Error fetching transaction details:", error);
    } finally {
      setLoading(false);
    }
  };
  
  const handleTabChange = (tabIndex) => {
    setActiveTab(tabIndex);
  };
  
  if (!order) return null;
  
  return (
    <Modal show={visible} onHide={onClose} size="xl" centered dialogClassName="modal-90w">
      <Modal.Header closeButton>
        <Modal.Title>Auth Transactions for Order: {order.number}</Modal.Title>
      </Modal.Header>
      
      <Modal.Body>
        {loading ? (
          <div className="text-center p-5">
            <Spin size="large" />
            <p className="mt-3">Loading transaction details...</p>
          </div>
        ) : transactions.length > 0 ? (
          <div>
            <ul className="nav nav-tabs mb-4">
              {transactions.map((transaction, index) => (
                <li className="nav-item" key={index}>
                  <button
                    className={`nav-link ${activeTab === index ? "active" : ""}`}
                    onClick={() => handleTabChange(index)}
                  >
                    Transaction #{index + 1}
                  </button>
                </li>
              ))}
            </ul>
            
            {transactions.map((transaction, index) => (
              <div
                key={index}
                className={`tab-pane ${activeTab === index ? "d-block" : "d-none"}`}
              >
                <TransactionDetails transaction={transaction} timezone={timezone} />
              </div>
            ))}
          </div>
        ) : (
          <p className="text-muted">No transaction details available.</p>
        )}
      </Modal.Body>
      
      <Modal.Footer>
        <Button variant="secondary" onClick={onClose}>
          Close
        </Button>
      </Modal.Footer>
    </Modal>
  );
};

export default RealAuthTransactionsModalForWeb;
